import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './status-tag.pcss'

const StatusTag = ({ text, statusColor }) => {
    return (
        <div
            className={classNames(
                'status-tag',
                `status-tag--status-${statusColor}`
            )}
        >
            <div
                className={classNames(
                    'status-tag__text'
                )}
            >
                <div className="status-tag__title">
                    {text}
                </div>
            </div>
        </div>
    )
}

StatusTag.propTypes = {
    text: PropTypes.string.isRequired,
    statusColor: PropTypes.string.isRequired,
}

export default StatusTag
